import type React from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { TwoDToThreeDStats } from "@/components/2d-to-3d/2d-to-3d-stats";
import { FeatureChart } from "@/components/feature-chart";
import { TwoDToThreeDSDK } from "@/components/2d-to-3d/2d-to-3d-sdk";
import { GenerationsList } from "@/components/generations-list";

const TwoDToThreeDPage: React.FC = () => {
  return (
    <>
      <main className="flex-1 space-y-6 p-2">
        <div className="space-y-2">
          <h2 className="text-3xl font-bold tracking-tight bg-gradient-to-r from-pink-500 to-purple-500 bg-clip-text text-transparent">
            2D to 3D
          </h2>
          <p className="text-muted-foreground">
            Monitor your 3D transformation performance and analytics
          </p>
        </div>

        <Tabs defaultValue="overview" className="space-y-6">
          <TabsList>
            <TabsTrigger value="overview">Overview</TabsTrigger>
            <TabsTrigger value="generations">Generations</TabsTrigger>
            <TabsTrigger value="playground">Playground</TabsTrigger>
          </TabsList>

          <TabsContent value="overview" className="space-y-6">
            {/* Feature Stats */}
            <TwoDToThreeDStats />

            {/* 3D Transformation Trends */}
            <Card>
              <CardHeader>
                <CardTitle>3D Transformation Trends</CardTitle>
                <CardDescription>Models created over time</CardDescription>
              </CardHeader>
              <CardContent>
                <FeatureChart
                  featureKey="twoDTo3D"
                  usersKey="twoDTo3DUsers"
                  dataLabel="Models Created"
                  color="#F3A712"
                  showUsers={true}
                />
              </CardContent>
            </Card>
          </TabsContent>

          <TabsContent value="generations" className="space-y-6">
            <GenerationsList type="2d-to-3d" />
          </TabsContent>

          <TabsContent value="playground" className="space-y-6">
            <div className="w-full mx-auto">
              <TwoDToThreeDSDK />
            </div>
          </TabsContent>
        </Tabs>
      </main>
    </>
  );
};

export default TwoDToThreeDPage;
